export const POLICY_GROUPS = Object.freeze([
  {
    title: "Orders and delivery",
    links: [
      ["Terms of sale", "/terms-of-sale"],
      ["Shipping & delivery", "/shipping"],
      ["Delivery problems", "/delivery-issues"],
      ["Returns & refunds", "/returns"],
      ["Order cancellation", "/cancellations"],
      ["International orders", "/international-orders"],
      ["Payment & pricing", "/payment-policy"],
    ],
  },
  {
    title: "Products and service",
    links: [
      ["Product information", "/product-information"],
      ["Product safety & care", "/product-safety"],
      ["Packaging", "/packaging"],
      ["Accessibility", "/accessibility"],
      ["FAQ", "/faq"],
      ["Contact information", "/contact-policy"],
    ],
  },
  {
    title: "Privacy and legal",
    links: [
      ["Privacy", "/privacy"],
      ["Consumer data rights", "/data-rights"],
      ["Cookie notice", "/cookies"],
      ["Terms of use", "/terms"],
      ["Intellectual property", "/intellectual-property"],
      ["Complaints & updates", "/complaints"],
    ],
  },
]);

export const HEADER_POLICY_LINKS = Object.freeze([
  ["Policy guide", "/policies"],
  ["Privacy", "/privacy"],
  ["Terms of sale", "/terms-of-sale"],
  ["Shipping", "/shipping"],
  ["Returns", "/returns"],
  ["FAQ", "/faq"],
  ["Cookies", "/cookies"],
]);
